module.exports = __webpack_public_path__ + "static/img/round.39349bd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/round.png
// module id = J8kb
// module chunks = 0